import React from 'react'; 
import moment from 'moment';
import { Alert, DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend( isSameOrAfter );
dayjs.extend( isSameOrBefore );

const FormItemDates = ( { hasRevision } ) => {
    return (
        <div style={ { marginTop: '24px' } }>
            
            { /* Start date */ }
            <Form.Item
                noStyle
                shouldUpdate={ ( prevValues, currentValues ) => 
                    prevValues.isPublished !== currentValues.isPublished ||
                    prevValues._availableAt !== currentValues._availableAt ||
                    prevValues._unavailableAt !== currentValues._unavailableAt }
            >
                { ( { getFieldValue } ) => {
                    return getFieldValue( 'isPublished' ) && hasRevision ? 
                        <>  
                            <Alert
                                description="This field cannot be changed while this objective is published."
                                type="warning"
                                style={ { marginBottom: '12px' } }
                            />

                            <Form.Item  
                                label={ `Start Date (${ Intl.DateTimeFormat().resolvedOptions().timeZone })` }
                                name="_availableAt"
                                rules={ [
                                    {
                                        message: 'Please add a start date',
                                        required: true,
                                    },
                                    {
                                        message: 'This date must be before the end date.',
                                        validateTrigger: [],
                                        validator: ( _, value ) => {
                                            const pubUn = getFieldValue( 'unavailableAt' );
                                                                                        
                                            if ( value && pubUn ) {
                                                if ( dayjs( value ).isBefore( pubUn  ) ) {
                                                    return Promise.resolve();
                                                } else {
                                                    return Promise.reject();
                                                }
                                            } else {
                                                return Promise.resolve();
                                            }
                                        }
                                    }
                                ] }
                            >
                                <DatePicker 
                                    inputReadOnly
                                    format="YYYY-MM-DD HH:mm"
                                    showNow={ false }
                                    showTime={ {
                                        defaultValue: dayjs( '00:00', 'HH:mm' )
                                    } }
                                    disabled={ true }
                                    disabledDate={ current => {
                                        const pubUn = getFieldValue( '_unavailableAt' );
                                                                                
                                        if ( !pubUn ) {
                                            return !current ||
                                                current.isBefore( dayjs(), 'day' );
                                        } else {
                                            return current.isBefore( dayjs(), 'day' ) ||
                                                current.isSameOrAfter( pubUn, 'day' );
                                        }
                                    } }
                                />
                            </Form.Item> 
                        </>
                        :
                        <>
                            <Form.Item  
                                label={ `Start Date (${ Intl.DateTimeFormat().resolvedOptions().timeZone })` }
                                name="_availableAt"
                                rules={ [
                                    {
                                        message: 'Please add a start date',
                                        required: true,
                                    },
                                    {
                                        message: 'This date must be before the end date.',
                                        validateTrigger: [],
                                        validator: ( _, value ) => {
                                            const pubUn = getFieldValue( 'unavailableAt' );
                                                                                        
                                            if ( value && pubUn ) {
                                                if ( dayjs( value ).isBefore( pubUn  ) ) {
                                                    return Promise.resolve();
                                                } else {
                                                    return Promise.reject();
                                                }
                                            } else {
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                    // {
                                    //     message: 'The start date and time must be in the future.',
                                    //     validateTrigger: [],
                                    //     validator: ( _, value ) => {
                                    //         if ( dayjs( value ).isAfter( dayjs(), 'minute' ) ) {
                                    //             return Promise.resolve();
                                    //         } else {
                                    //             return Promise.reject();
                                    //         }
                                    //     }
                                    // }
                                ] }
                            >
                                <DatePicker 
                                    inputReadOnly
                                    format="YYYY-MM-DD HH:mm"
                                    showNow={ false }
                                    showTime={ {
                                        defaultValue: dayjs( '00:00', 'HH:mm' ),
                                        minuteStep: 5
                                    } }
                                    disabledDate={ current => { 
                                        const pubUn = getFieldValue( '_unavailableAt' );
                                                                                
                                        if ( !pubUn ) {
                                            return !current ||
                                                current.isBefore( dayjs(), 'day' );
                                        } else {
                                            return current.isBefore( dayjs(), 'day' ) ||
                                                current.isSameOrAfter( pubUn, 'day' );
                                        }
                                    } }
                                />
                            </Form.Item> 
                        </>;
                } }
            </Form.Item> 

            { /* End date */ }
            <Form.Item
                noStyle
                shouldUpdate={ ( prevValues, currentValues ) => 
                    prevValues.isPublished !== currentValues.isPublished ||
                    prevValues._availableAt !== currentValues._availableAt ||
                    prevValues._unavailableAt !== currentValues._unavailableAt }
            >
                { ( { getFieldValue } ) => {
                    return getFieldValue( 'isPublished' ) && hasRevision ? 
                        <>  
                            <Alert
                                description="This field cannot be changed while this objective is published."
                                type="warning"
                                style={ { marginBottom: '12px' } }
                            />

                            <Form.Item  
                                label={ `End Date (${ Intl.DateTimeFormat().resolvedOptions().timeZone })` }
                                name="_unavailableAt"
                            >
                                <DatePicker 
                                    inputReadOnly
                                    format="YYYY-MM-DD HH:mm"
                                    showNow={ false }
                                    disabled={ true }
                                    showTime={ {
                                        defaultValue: dayjs( '00:00', 'HH:mm' ),
                                        minuteStep: 5
                                    } }
                                    disabledDate={ current => {
                                        if ( !getFieldValue( '_availableAt' ) ) {
                                            return current.isSameOrBefore( dayjs(), 'day' );
                                        }
    
                                        return  current.isSameOrBefore( dayjs( getFieldValue( '_availableAt' ) ), 'day' );
                                    } }
                                />
                            </Form.Item> 
                        </>
                        :
                        <Form.Item  
                            label={ `End Date (${ Intl.DateTimeFormat().resolvedOptions().timeZone })` }
                            name="_unavailableAt"
                            rules={ [
                                {
                                    message: 'The end date and time must be in the future.',
                                    validateTrigger: [],
                                    validator: ( _, value ) => {
                                    
                                        return !value || dayjs( value ).isAfter( dayjs(), 'minute' ) 
                                            ? Promise.resolve() 
                                            : Promise.reject();
                                    }
                                }
                            ] }
                        >
                            <DatePicker 
                                inputReadOnly
                                format="YYYY-MM-DD HH:mm"
                                showNow={ false }
                                showTime={ {
                                    defaultValue: dayjs( '00:00', 'HH:mm' ),
                                    minuteStep: 5
                                } }
                                disabledDate={ current => {
                                    if ( !getFieldValue( '_availableAt' ) ) {
                                        return current.isBefore( dayjs(), 'day' );
                                    }

                                    return current.isBefore( dayjs( getFieldValue( '_availableAt' ) ), 'day' );
                                } }
                            />
                        </Form.Item>;
                }   }
            </Form.Item> 
        </div>
    );
};

export default FormItemDates;
